import React, { useMemo, useState, useEffect } from 'react';
import { isValidDateTime } from '../../../support/date';
import { CALL_ROW } from '../../../support/cypressTags';
import EllipsisText from '../EllipsisText';
import DatePicker from './DatePicker';

/**
 * Inline date picker
 * @param {number} occurrenceDate: A number representing the milliseconds elapsed between
 *    1 January 1970 00:00:00 UTC and the given value.
 * @param {function} onSave: hook for saving an updated Date
 * @param {Object} styles: provided styling classes
 * @returns {JSX.Element}
 * @constructor
 */
const CallDate = ({ occurrenceDate, onSave, styles }) => {
  // States
  const [date, setDate] = useState(new Date(occurrenceDate));
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    setDate(new Date(occurrenceDate));
  }, [occurrenceDate]);

  const handleOnCloseDatePicker = (_date) => {
    setDate(_date);
    setEditing(false);

    onSave && onSave({ occurrence_date: _date.getTime() });
  };

  const dateText = useMemo(() => {
    let locale = navigator.language;

    // Restricts locale usage to English variants only (what DatePicker supports);
    // other locales are replaced with "en-US".
    if (!/^en/g.test(locale)) {
      locale = 'en-US';
    }

    return new Date(date).toLocaleString(locale, {
      weekday: 'short',
      day: 'numeric',
      month: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  }, [date]);

  return (
    <>
      {editing ? (
        <td data-cy={CALL_ROW.DATE}>
          <DatePicker
            open
            focusPicker
            occurrenceDate={occurrenceDate}
            onChange={setDate}
            onClose={handleOnCloseDatePicker}
            dateLabelCypressTag={CALL_ROW.DATE_INNER_LABEL}
            dateButtonCypressTag={CALL_ROW.DATE_DAY_BUTTON}
          />
        </td>
      ) : (
        <td data-cy={CALL_ROW.DATE} className={styles.date} onClick={() => setEditing(true)}>
          <div>
            <time dateTime={isValidDateTime(date) ? date.toISOString() : ''}>
              <EllipsisText text={dateText} />
            </time>
          </div>
        </td>
      )}
    </>
  );
};

export default CallDate;
